import React, { useEffect, Dispatch, SetStateAction, useState } from "react";
import styled from "styled-components";
import DropdownQuestion from "../../../questionnaire/components/DropDownQuestion";
import TextInputQuestion from "../../../questionnaire/components/TextInputQuestion";
import { useQuestionnaire } from "../../../../contexts/QuestionnaireContext";
import { QuestionDefinitions } from "./QuestionDefinitions";
import { BigsSelect } from "../../BigsBcrWrapper";
import FormUtil from "../../../../util/FormUtil";
import { getJurisdictionsAvailableForUpload } from "../../../../api/ConsentFormApi";

const Container = styled.div.attrs(() => ({
    className: "ml-3 mr-3",
}))``;

const DropDownContent = styled.div`
    margin: 20px 0px 0px 0px;
    width: 350px;
`;

type QuestionnaireSectionProps = {
    personnel: any;
    jurisdictionForUpload: { label: string; value: string };
    setJurisdictionForUpload: Dispatch<SetStateAction<{ label: string; value: string }>>;
    questionnaireCompletedStatus: { completed: boolean; questionnaireAnswers: {} };
    jurisdictionOptions: { label: string; value: string }[];
    setJurisdictionOptions: Dispatch<SetStateAction<{ label: string; value: string }[]>>;
};

const QuestionnaireContainer = styled.div.attrs(() => ({
    className: "d-flex justify-content-between flex-wrap",
}))``;

const QuestionnaireSection: React.FC<QuestionnaireSectionProps> = ({
    personnel,
    jurisdictionForUpload,
    setJurisdictionForUpload,
    questionnaireCompletedStatus,
    jurisdictionOptions,
    setJurisdictionOptions,
}) => {
    const [showJurisdictionUpload, setShowJurisdictionUpload] = useState<boolean>(false);
    const {
        questionnaire,
        dispatchQuestionnaire,
        getJurisdictionOptionsFromQuestionnaire,
    } = useQuestionnaire();

    useEffect(() => {
        QuestionDefinitions.sort((a, b) => a.order - b.order);
        dispatchQuestionnaire({
            type: "setShortQuestionnaire",
        });
    }, []);

    useEffect(() => {
        const options = new Array<{ label: string; value: string; isCompleted: boolean }>();
        // if (jurisdictionOptions.length === 0) {
        getJurisdictionsAvailableForUpload(personnel?.id).then(response => {
            if (!questionnaire.isPreExisting) {
                getJurisdictionOptionsFromQuestionnaire().forEach(jurisdiction => {
                    if (!options.find(opt => opt.value === jurisdiction.value)) {
                        options.push({ ...jurisdiction, isCompleted: false });
                    }
                });
            }
            response.map((jurisdiction: any) => {
                if (!options.find(opt => opt.value === jurisdiction.name)) {
                    options.push({
                        value: jurisdiction.name,
                        label: FormUtil.formatJurisdiction(jurisdiction.name),
                        isCompleted: jurisdiction.completed,
                    });
                }
            });
            setJurisdictionForUpload(null);
            setJurisdictionOptions(Array.from(options));
        });
        // }
    }, [questionnaire, questionnaireCompletedStatus]);

    useEffect(() => {
        setShowJurisdictionUpload(questionnaire?.shortQuestionnaireSubmittable);
    }, [questionnaire]);

    return (
        <Container>
            <QuestionnaireContainer>
                {QuestionDefinitions.map(question => {
                    switch (question.type) {
                        case "DropDown":
                            return <DropdownQuestion key={question.id} questionDef={question} />;
                        case "Text":
                            return <TextInputQuestion key={question.id} questionDef={question} />;
                    }
                })}
                <>
                    {showJurisdictionUpload ? (
                        <DropDownContent>
                            <label className="required">
                                What country form do you need to upload?
                            </label>
                            <BigsSelect
                                onChange={option => {
                                    setJurisdictionForUpload(option);
                                }}
                                options={jurisdictionOptions}
                                value={jurisdictionForUpload}
                            />
                        </DropDownContent>
                    ) : null}
                </>
            </QuestionnaireContainer>
        </Container>
    );
};

export default QuestionnaireSection;
